<template>
  <div class="edit-event-dialog">
    <v-dialog v-model="open" width="400" persistent>
      <v-card class="event-form">
        <v-card-title class="p-3" color="primary">
          <v-icon class="mr-3" @click="close">
            mdi-close
          </v-icon>
          {{ isEdit ? $t('EditRecurringEventDialog.EditRecurringEvent') : $t('EditRecurringEventDialog.DeleteRecurringEvent') }} 
        </v-card-title>
        <validation-observer ref="observer">
          <v-card-text class="pt-5">
            <validation-provider v-slot="{ errors }" name="editOption" rules="required">
              <v-radio-group v-model="editRecurringEventType" :error-messages="errors">
                <v-radio :label="$t('EditRecurringEventDialog.ThisEvent')" :value="editRecurringEventTypes.SelectedEvent"></v-radio>
                <v-radio :label="$t('EditRecurringEventDialog.ThisAndFollowingEvents')" :value="editRecurringEventTypes.CurrentAndfollowingEvents">
                </v-radio>
                <v-radio :label="$t('EditRecurringEventDialog.AllEvents')"  :value="editRecurringEventTypes.AllEvents"></v-radio>
              </v-radio-group>
            </validation-provider>
          </v-card-text>
          <v-card-actions class="pt-0 pb-4 d-flex align-items-center justify-content-between">
            <v-btn class="btn-cancel" @click="cancel">
              {{$t('GeneralTranslations.Cancel')}}
            </v-btn>
            <v-btn type="submit" @click="ok" class="btn-default">
              {{$t('GeneralTranslations.Ok')}}
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "@/plugins/vee-validate";
import { EditRecurringEventTypes } from '@/enums/EditRecurringEventTypes';
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    editRecurringEventType: {
      type: String,
      default: EditRecurringEventTypes.SelectedEvent
    },
    value: Boolean
  },
  data() {
    return {
      loading: false,
      editRecurringEventTypes: EditRecurringEventTypes,
      isEdit: true
    };
  },

  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  methods: {
    ok() {
      if (!this.editRecurringEventType) {
        this.$refs.observer.setErrors({
          editOption: [this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.PleaseSelectAnOption']]
        });
        return
      }

      this.$emit("editRecurringOptionSelected", this.editRecurringEventType);
    },
    close() {
      this.open = false
      this.$emit("closeRecurringOptionSelected");
    },
    cancel() {
      this.close()
    },
    changeTitle(params) {
      if (params.isDelete) {
        this.isEdit = false;
      } else {
        this.isEdit = true;
      }
    }
  }
};
</script>

<style></style>
